var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clipboard-container d-flex align-items-center"},[_c('div',{staticClass:"clipboard-text"},[_c('p',[_vm._v(_vm._s(_vm.value ? _vm.value : _vm.placeholder))])]),_c('button',{staticClass:"clipboard-button button button--primary",on:{"click":_vm.copyText}},[_vm._v("Copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }